$('.slide').slick({
  infinite: false,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
      }
    }

  ]
});


var location_url = window.location.href;

var parts = location_url.split('/');
var lastSegment = parts.pop() || parts.pop();  // handle potential trailing slash

if (lastSegment == 'men'){
$(".men").addClass('active');
    
}if (lastSegment == 'women'){
$(".women").addClass('active');
    
}

  var urlPath = window.location.pathname;
  if (urlPath.includes("/men")) {
    $(".men").addClass('active');
  } else if (urlPath.includes("/women")) {
$(".women").addClass('active');
  }

d





$(document).ready(function() {
    $('label').click(function() {
        $('label').removeClass('active'); // remove active class from all labels
        $(this).addClass('active'); // add active class to the clicked label
    });
});









$(document).ready(function() {
  $('label[for="tab1"]').click(function() {
    $('a[href="{{ block.settings.url }}"]').click();
  });
});

$(document).ready(function() {
  $('label[for="tab2"]').click(function() {
    $('a[href="{{ block.settings.url2 }}"]').click();
  });
});





document.querySelector('a[href="?filter.p.tag=Mens"]').addEventListener('click', function(e) {
   
    this.classList.add('active');

    sessionStorage.setItem('activeTab', '?filter.p.tag=Mens');
});


document.addEventListener('DOMContentLoaded', function() {

    var activeTab = sessionStorage.getItem('activeTab');

    // 
    if(activeTab) {
        document.querySelector('a[href="' + activeTab + '"]').classList.add('active');
    }
});



$('label[for="tab2"]').click(function () {
   
   $('.tab.men').css("display", "none");   
});

